
import {defineComponent} from 'vue'
import {UtilityHelper} from "@/helpers/UtilityHelper";
import InputText from "@/components/UI/InputText.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";
import {EnumClassNamePimEnum} from "@/models/enum/EnumClassNamePimEnum";
import {PimFeedbackRestDtoModel} from "@/models/api/pharma-pim-mgmt/PimFeedbackRestDtoModel";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";
import {PropType} from "vue/dist/vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {AutoSaveFeedbackStatusEnum} from "@/models/enum/AutoSaveFeedbackStatusEnum";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "PimFeedbackPanel",
  emits: ["submitPimFeedback", "submitPimFeedbackCancel"],
  components: {GenericFormWrapper, InputTextEditor, InputText, InputSelect},
  props: {
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    isGeneralRemark: {
      type: Boolean,
      required: true,
    },
    isShowFieldCode: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldCode: {
      type: String,
      required: false,
    },
    textFragmentId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      localFeedback: PimFeedbackRestDtoModel.createWithDefaults(),
      localFieldCode: this.fieldCode,
      originalRemarks: '' as string,
      enumFragmentNameCode: [] as CodeDescriptionRestDto[],
      enumPimProductFieldCode: [] as CodeDescriptionRestDto[],
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper
    },
  },
  methods: {
    async initialize(): Promise<void> {
      [
        this.enumFragmentNameCode,
        this.enumPimProductFieldCode
      ] = await Promise.all([
        EnumRestService.getInstance().getEnumValuesByClassName(EnumClassNamePimEnum.TEXT_FRAGMENT_NAME, DpModuleEnum.CPC),
        EnumRestService.getInstance().getEnumValuesByClassName(EnumClassNamePimEnum.PIM_PRODUCT_FIELD, DpModuleEnum.CPC)
      ]);
      this.reloadContent();
    },
    reloadContent(): void {
      this.localFeedback.field_code = this.fieldCode;
      this.localFeedback.text_fragment_id = this.textFragmentId;
      this.originalRemarks = this.localFeedback.remarks ?? '';
      this.checkFormDataChanged();
    },
    checkFormDataChanged(): void {
      if ((this.localFeedback.remarks ?? '') === this.originalRemarks
        && (this.localFeedback.proposed_new_value ?? '')  === '') {
        this.pageUI.setAutoSaveFeedbackStatus(AutoSaveFeedbackStatusEnum.NONE);
        this.pageUI.setCanSubmit(false);
      } else {
        this.pageUI.setAutoSaveFeedbackStatus(AutoSaveFeedbackStatusEnum.UNSAVED_CHANGES);
        this.pageUI.setCanSubmit(true);
      }
    },
    submitPimFeedback(): void {
      this.$emit('submitPimFeedback', this.localFeedback);
    },
    submitPimFeedbackCancel(): void {
      this.$emit('submitPimFeedbackCancel');
    },
  }
})
